import React, { useState } from "react";
import styles from "./index.module.css";
import Button from "shared/Button";
import TextInput from "shared/@forms/TextInput";
import Select from "shared/@forms/Select";
import TextArea from "shared/@forms/TextArea";
import { useAwards } from "../useAwards";
import { useEditLoaPlugin } from "./useEditLoaPlugin";

const EditModalContent = (props) => {
  const {
    submit,

    losAwardId,
    setLosAwardId,

    sponsor,
    setSponsor,

    platinum,
    setPlatinum,

    emerald,
    setEmerald,

    diamond,
    setDiamond,

    wwgSignoff,
    setWwgSignoff,

    uplineSignoff,
    setUplineSignoff,

    notes,
    setNotes,
  } = useEditLoaPlugin(props.record.iboNumber, props.record, props.refresh);

  const { awards, loading, isWaiting, cancelOrder } = useAwards();

  return (
    <>
      <form style={{ width: "500px" }}>
        <div>
          <h3>Ibo Number</h3>
          <TextInput defaultValue={props.record.iboNumber} />
        </div>

        <div className={styles.padding}>
          <h3>Award</h3>
          <Select
            onChange={(e) => {
              setLosAwardId(Number(e.target.value));
            }}
          >
            {awards ? (
              awards.map((a, i) => {
                return losAwardId === a.id ? (
                  <option value={a.id}>{a.wwgDesc}</option>
                ) : null;
              })
            ) : (
              <option>Loading....</option>
            )}

            {awards
              ? awards.map((a, i) => {
                  return losAwardId !== a.id ? (
                    <option value={a.id}>{a.wwgDesc}</option>
                  ) : null;
                })
              : null}
          </Select>
        </div>

        <div className={styles.doubleInputRow}>
          <div>
            <h3>Sponsor Ibo</h3>
            <TextInput
              defaultValue={sponsor}
              className={styles.modalTextInput}
              onChange={(e) => {
                setSponsor(e.target.value);
              }}
            />
          </div>

          <div>
            <h3>Platinum Ibo</h3>
            <TextInput
              defaultValue={platinum}
              className={styles.modalTextInput}
              onChange={(e) => {
                setPlatinum(e.target.value);
              }}
            />
          </div>
        </div>

        <div className={styles.doubleInputRow}>
          <div>
            <h3>Emerald Ibo</h3>
            <TextInput
              defaultValue={emerald}
              className={styles.modalTextInput}
              onChange={(e) => {
                setEmerald(e.target.value);
              }}
            />
          </div>

          <div>
            <h3>Diamond Ibo</h3>
            <TextInput
              defaultValue={diamond}
              className={styles.modalTextInput}
              onChange={(e) => {
                setDiamond(e.target.value);
              }}
            />
          </div>
        </div>

        <div className={styles.doubleInputRow}>
          <div>
            <h3>WWG Signoff</h3>
            <TextInput
              defaultValue={wwgSignoff}
              className={styles.modalTextInput}
              onChange={(e) => {
                setWwgSignoff(e.target.value);
              }}
            />
          </div>

          <div>
            <h3>Upline Signoff</h3>
            <TextInput
              defaultValue={uplineSignoff}
              className={styles.modalTextInput}
              onChange={(e) => {
                setUplineSignoff(e.target.value);
              }}
            />
          </div>
        </div>

        <div className={styles.padding}>
          <h3>Notes</h3>
          <TextArea
            value={notes ? notes : ""}
            onChange={(e) => {
              setNotes(e.target.value);
            }}
          />
        </div>

        <div className={styles.buttonRow}>
          <Button className={styles.cancelButton} onClick={props.onClose}>
            Cancel
          </Button>
          <Button
            className={styles.addButton}
            onClick={(e) => {
              e.preventDefault();
              submit();
              props.refresh();
            }}
          >
            Save Plugin
          </Button>
        </div>
      </form>
    </>
  );
};
export default EditModalContent;
